import { withTranslatedMeta } from 'i18n/utils'

import { userSelector } from 'auth/selectors'
import { selectedCreditCardSelector } from 'booking/selectors'
import { selectCreditCard, clearSelectedRate } from 'booking/actions'

import ErrorMessage from '@components/ErrorMessage'
import Button from '@components/Button'

import { makePurchase } from '../actions'
import * as selectors from '../selectors'
import CreditCardList from './CreditCardList'
import Contents from './Contents'

import './styles.scss'

const Basket = ({
    user,
    pending,
    isBasketEmpty,
    cards,
    allowPurchase,
    selectCreditCard,
    selectedCreditCard,
    makePurchase,
    addAnotherBookingUrl,
    purchaseCompleted,
    history,
    deliveryAddressString,
    hasMonthlyPass,
    clearSelectedRate,
}) => {
    const [priceBreakdownModalOpen, setPriceBreakdownModalOpen] = React.useState(false)

    React.useEffect(() => {
        clearSelectedRate()
    }, [])
    React.useEffect(() => {
        if (cards.length > 0) {
            const card = cards.find(card => card.default) || cards[0]
            selectCreditCard(card.id)
        }
    }, [selectCreditCard, cards])

    React.useEffect(() => {
        purchaseCompleted && history.push('confirmation')
    }, [purchaseCompleted])

    const purchaseError = pending instanceof Error ? pending : undefined

    return (
        <>
            <div className="container basket-container">
                <div className={`basket ${pending ? (pending instanceof Error ? 'error' : 'pending') : ''}`}>
                    <h3>
                        <T>{isBasketEmpty ? 'basket.empty.title' : 'basket.confirm.title'}</T>
                    </h3>
                    <Contents
                        priceBreakdownModalOpen={priceBreakdownModalOpen}
                        setPriceBreakdownModalOpen={setPriceBreakdownModalOpen}
                        makePurchase={() => makePurchase()}
                        disabled={!selectedCreditCard || !allowPurchase}
                        error={purchaseError}
                    />
                    {user && !isBasketEmpty ? (
                        <div>
                            {hasMonthlyPass && (
                                <div className="mb-5 basket-container__address">
                                    <h5>
                                        <T>basket.confirmed.details</T>
                                    </h5>
                                    <p>{deliveryAddressString}</p>
                                </div>
                            )}

                            <div className="basket-container__select">
                                <p>
                                    <T>basket.select.payment.card</T>
                                </p>
                                <CreditCardList
                                    selectedCard={selectedCreditCard}
                                    onCardSelected={selectCreditCard}
                                    disabled={pending === true}
                                />
                            </div>
                            {purchaseError && (
                                <ErrorMessage className="purchase-error" messages={[purchaseError.message]} />
                            )}

                            <div className="row">
                                <div className="col-md-3 push-md-2">
                                    <Button
                                        size="large"
                                        btnStyle="outline"
                                        block
                                        href={addAnotherBookingUrl ? addAnotherBookingUrl : '/map'}
                                        className="mb-3">
                                        <T>basket.add.another.booking.btn.label</T>
                                    </Button>
                                </div>
                                <div className="col-md-3 push-md-4">
                                    <Button
                                        size="large"
                                        isLoading={pending === true}
                                        block
                                        className="mb-3"
                                        disabled={!selectedCreditCard || !allowPurchase || pending === true}
                                        onClick={() => makePurchase()}>
                                        <T>basket.make.purchase.btn.label</T>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row justify-content-center">
                            <div className="col-md-4">
                                <Button
                                    size="large"
                                    btnStyle="outline"
                                    block
                                    href={addAnotherBookingUrl ? addAnotherBookingUrl : '/map'}
                                    className="btn-block mb-3">
                                    <T>basket.add.booking.btn.label</T>
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
                {user && !isBasketEmpty && (
                    <p className="basket-container__terms">
                        <T>basket.confirmed.terms.label</T>{' '}
                        <Link to="/terms-and-conditions">
                            <T>basket.confirm.terms.link</T>
                        </Link>
                    </p>
                )}
            </div>
        </>
    )
}

export default compose(
    withTranslatedMeta('basket.confirm.title'),
    connect(
        createStructuredSelector({
            cards: selectors.creditCardsSelector,
            user: userSelector,
            paymentTotal: selectors.totalSelector,
            pending: selectors.makePurchasePendingSelector,

            hasMonthlyPass: selectors.hasMonthlyPassSelector,
            isBasketEmpty: selectors.isEmptySelector,

            allowPurchase: selectors.allowPurchaseSelector,
            addAnotherBookingUrl: selectors.addAnotherBookingUrlSelector,

            purchaseCompleted: selectors.purchaseCompletedSelector,
            selectedCreditCard: selectedCreditCardSelector,
            deliveryAddressString: selectors.addressToStringSelector,
        }),
        { makePurchase, selectCreditCard, clearSelectedRate }
    )
)(Basket)
